import React from 'react';
import useTheme from '@material-ui/core/styles/useTheme';
import FsCheckboxLargeDefault from 'ui-elements/icons/FsCheckboxLargeDefault';
import FsCheckboxLargeSelectedIcon from 'ui-elements/icons/FsCheckboxLargeSelected';
import { purple } from 'globals/colors';
import {
  ContainerBox,
  IconContainerBox,
  Label,
  Line,
  Value,
} from './FsTileTab.style-elements';
import {
  getContainerBoxStyle,
  getLabelStyle,
  getLineStyle,
  getValueStyle,
} from './FsTileTab.style';

export interface TileTabDataProps {
  label: string;
  value: string;
  id: string;
}

export interface TileTabProps extends TileTabDataProps {
  activeColor?: string;
  isFirst?: boolean;
  isLast?: boolean;
  onClick?: (isActive: boolean) => void;
  isActive?: boolean;
}

const FsTileTab: React.FC<TileTabProps> = ({
  label = 'No Label',
  value = 'No Value',
  isFirst = false,
  isLast = false,
  isActive = false,
  activeColor = purple.BRAND,
  onClick,
}) => {
  const theme = useTheme();

  const clickHandler = (): void => {
    const newValue = !isActive;
    if (onClick) {
      onClick(newValue);
    }
  };

  const containerStyle = getContainerBoxStyle({
    isActive,
    activeColor,
    isFirst,
    isLast,
  });

  const labelStyle = getLabelStyle({
    isActive,
    theme,
  });

  const valueStyle = getValueStyle({
    isActive,
    theme,
  });

  const lineStyle = getLineStyle({
    isActive,
    activeColor,
    theme,
  });

  return (
    <ContainerBox onClick={clickHandler} style={containerStyle}>
      <IconContainerBox>
        {isActive ? (
          <FsCheckboxLargeSelectedIcon color={theme.palette.common.white} />
        ) : (
          <FsCheckboxLargeDefault color={theme.palette.grey[300]} />
        )}
      </IconContainerBox>
      <Label style={labelStyle}>{label}</Label>
      <Line style={lineStyle} />
      <Value style={valueStyle}>{value}</Value>
    </ContainerBox>
  );
};

export default FsTileTab;
